// BBQ filter-ux (PLAN-FILTER-UX §11). Horizon's facets.js pushes a history entry for every filter, sort and
// chip change but registers no popstate renderer, so Back/Forward changed the URL and left the grid stale.
// Loaded only from blocks/filters.liquid (collection and search pages), where every history entry is a
// filter/sort/page state: a full render of the restored URL (sort_by included) is the simple correct answer.
// Fragment-only navigation (the skip-to-results link, card #anchors) also fires popstate; those keep the same
// path + query and are ignored. Nothing is pushed to history here.
if (!window.__bbqFacetsHistory) {
  window.__bbqFacetsHistory = true;
  const key = () => window.location.pathname + window.location.search;
  let rendered = key();
  const sync = () => { rendered = key(); };
  // facets.js changes the URL with pushState (no event), so record the URL the page now shows after each update.
  for (const type of ['collection:update', 'search:update']) document.addEventListener(type, () => setTimeout(sync, 0));
  const push = history.pushState;
  history.pushState = function (...args) {
    const r = push.apply(this, args);
    sync();
    return r;
  };
  window.addEventListener('popstate', () => {
    if (key() !== rendered) window.location.reload();
  });
}
